import {
  AT_TYPE_CART_BOTTOM,
  AT_TYPE_CART_TOP,
  DEFAULT_WIDGETS,
  IT_TYPE_CART_BOTTOM,
  IT_TYPE_CART_TOP,
  MP_AT_TYPE_CART_BOTTOM,
  MP_AT_TYPE_CART_TOP,
  TYPE_CART_BOTTOM,
  TYPE_CART_TOP,
} from 'shared/consts/crosssellWidgets'

export const shouldShowBuyButton = (wid: number): boolean =>
  wid === DEFAULT_WIDGETS[TYPE_CART_TOP] ||
  wid === DEFAULT_WIDGETS[TYPE_CART_BOTTOM] ||
  wid === AT_TYPE_CART_TOP ||
  wid === AT_TYPE_CART_BOTTOM ||
  wid === IT_TYPE_CART_TOP ||
  wid === IT_TYPE_CART_BOTTOM ||
  wid === MP_AT_TYPE_CART_TOP ||
  wid === MP_AT_TYPE_CART_BOTTOM
